/**Dependencies */
import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";

/**Components */
import { SectionAdvise } from "../components/SectionAdvise";
import { SectionPays } from "../components/SectionPays";
import { settings } from "../utils";
import { CarouselCards } from "../components/CarouselCards";
import { PrincipalBanner } from "../components/PrincipalBanner";
import { BannerParallax } from "../components/BannerParallax";
import { CardCarrousel } from "../components/CardCarrousel";
import Slider from "react-slick";

/**Styles */
import "../styles/hotels.scss";

/**Images */
import imgEuropa from "../images2/Europa.png";
import imgPlayas from "../images2/Playas.png";
import imgAsia from "../images2/Asia.png";
import imgSudamerica from "../images2/Sudamerica.png";
import imgEuropaMovil from "../images2/Europa_movil.png";
import imgSudamericaMovil from "../images2/Sudamérica_movil.png";
import bannerExperiencia1 from "../images2/Banner_experiencia_1.png";
import bannerExperiencia2 from "../images2/Banner_experiencia_2.png";
import moonPalace from "../images2/Moon Palace Cancun.png";
import hiltonCancun from "../images2/Hilton Cancun Mar Caribe.png";
import fiestaAmericana from "../images2/Grand Fiesta Americana.png";
import dinkColletion from "../images2/Dink-coleccion.png";
import spiritualColletion from "../images2/Spiritual-coleccion.png";
import adventureCollection from "../images2/Adventure-coleccion.png";
import loveCollection from "../images2/Love-coleccion.png";
import bussinesCollection from "../images2/Business-coleccion.png";
import ecoCollection from "../images2/Eco-coleccion.png";
import parallaxExperiencias from "../images2/parallax-experiencia.png";
import { getAllDestinations } from "../services/adminProductService";
import { useNavigate } from "react-router-dom";
import { CarruselHotels } from "../components/CarruselHotels";
import { getCollections } from "../services/CollectionsService";
import { CheckOutCart } from "../components/CheckOutCart";
import { useLocation } from "react-router-dom";
const arrBanner = [
  {
    image: bannerExperiencia1,
  },
  {
    image: bannerExperiencia2,
  },
];
export const Experiencias = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [showAlert, setShowAlert] = useState(false);
  const [arrSession, setArrSession] = useState(
    JSON.parse(sessionStorage.getItem("datosReserva")) || []
  );
  const [destinies] = useState([
    {
      hotel: "Seadust Cancún Family Resort",
      location: "Cancún, México.",
      price: "$3,937",
      days: "10",
      img: moonPalace,
      stars: "5.0",
    },
    {
      hotel: "Hilton Cancun Mar Caribe All-Inclusive Resort",
      location: "Cancún, México",
      price: "$4,466",
      days: "10",
      img: hiltonCancun,
      stars: "4.5",
    },
    {
      hotel: "Moon Palace Cancún",
      location: "Cancún, México",
      price: "$8,061",
      days: "10",
      img: fiestaAmericana,
      stars: "4.3",
    },
  ]);
  const cardsColecciones = [
    {
      title: "Dink",
      img: dinkColletion,
      btnText: "Descubre más",
      category: "dink",
    },
    {
      title: "Spiritual",
      img: spiritualColletion,
      btnText: "Descubre más",
      category: "spiritual",
    },
    {
      title: "Adventure",
      img: adventureCollection,
      btnText: "Descubre más",
      category: "adventure",
    },
    {
      title: "Love",
      img: loveCollection,
      btnText: "Descubre más",
      category: "love",
    },
    {
      title: "Business",
      img: bussinesCollection,
      btnText: "Descubre más",
      category: "business",
    },
    {
      title: "Eco",
      img: ecoCollection,
      btnText: "Descubre más",
      category: "eco",
    },
  ];
  const navigate = useNavigate();
  const today = new Date();
  const [destinations, setDestinations] = useState([]);
  const [collections, setCollections] = useState([]);
  const [dates] = useState([
    new Date(today.getFullYear(), today.getMonth(), today.getDate() + 15)
      .toISOString()
      .split("T")[0],
    new Date(today.getFullYear(), today.getMonth(), today.getDate() + 17)
      .toISOString()
      .split("T")[0],
  ]);
  const saveURL = (urlPath, urlSearch) => {
    // Crear un array de habitaciones a agregar
    const newUrl = {
      pathName: urlPath,
      search: urlSearch,
    };
    // Agregar nuevas habitaciones correctamente
    const urlNew = [newUrl];

    // Guardar en sessionStorage
    const setDatos = {
      url: urlNew,
    };

    sessionStorage.setItem("urlSession", JSON.stringify(setDatos));
  };
  /** Este useEffect se encarga de obtener los destinos administrados desde el panel de administracion */
  useEffect(() => {
    const getDestinations = async () => {
      try {
        const response = await getAllDestinations(3);
        setDestinations(response);
      } catch (error) {
        throw new Error("Error fetching Data. Destinations: " + error);
      }
    };
    getDestinations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const obtenerCollections = async () => {
      try {
        const response = await getCollections();
        setCollections(response);
      } catch (error) {
        throw new Error("Error fetching Data. Destinations: " + error);
      }
    };
    obtenerCollections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <PrincipalBanner
        idSeccion={3}
        principalTitle="Experiencias inolvidables en todo el mundo"
      />

      <div className="section-activities container pb-5">
        <h1 className="pb-5 pt-5 fw-semibold text-center d-flex justify-content-center">
          Explora y vive experiencias <br /> increíbles
        </h1>
        <Row className="d-lg-flex d-none m-0">
          <Col
            lg={4}
            md={6}
            sm={12}
            className="image-box rounded-5 p-0 shadow"
            style={{ cursor: "pointer" }}
            onClick={() => [
              window.scrollTo({ top: 0, behavior: "smooth" }),
              navigate(
                `/experiencias-resultado?t=destination&id=${destinations?.[0]?.id_destino}&in=${dates?.[0]}&out=${dates?.[1]}&pax=2|21,21|0|0`
              ),
            ]}
          >
            <img
              src={
                "https://panel.marzahtravel.com/assets/uploads/carruseles/destinos/" +
                destinations?.[0]?.imagen_destino
              }
              className="img-collage shadow hover-image w-100"
              style={{ height: "408px" }}
              alt=""
            />
            <div className="overlay-text text-center align-items-center w-100">
              <span
                className="text-white"
                style={{
                  fontSize: "3rem",
                  textShadow: "rgba(0, 0, 0, 0.51) 0px 1rem 3rem",
                }}
              >
                {destinations?.[0]?.nombre_destino?.substring(0, 20)}...
              </span>
            </div>
          </Col>
          <Col lg={4} className="d-flex">
            <div className="d-grid w-100">
              <div
                className="image-box spacing-top rounded-5 p-0 shadow"
                style={{ cursor: "pointer" }}
                onClick={() => [
                  window.scrollTo({ top: 0, behavior: "smooth" }),
                  navigate(
                    `/experiencias-resultado?t=destination&id=${destinations?.[1]?.id_destino}&in=${dates?.[0]}&out=${dates?.[1]}&pax=2|21,21|0|0`
                  ),
                ]}
              >
                <img
                  src={
                    "https://panel.marzahtravel.com/assets/uploads/carruseles/destinos/" +
                    destinations?.[1]?.imagen_destino
                  }
                  className="img-collage shadow hover-image w-100"
                  alt=""
                  style={{
                    height: "192px",
                    objectFit: "cover",
                  }}
                />
                <div className="overlay-text text-center align-items-center w-100">
                  <span
                    className="text-white"
                    style={{
                      fontSize: "3rem",
                      textShadow: "rgba(0, 0, 0, 0.51) 0px 1rem 3rem",
                    }}
                  >
                    {destinations?.[1]?.nombre_destino?.substring(0, 20)}...
                  </span>
                </div>
              </div>
              <div
                className="image-box mt-4 rounded-5 p-0 shadow"
                style={{ cursor: "pointer" }}
                onClick={() => [
                  window.scrollTo({ top: 0, behavior: "smooth" }),
                  navigate(
                    `/experiencias-resultado?t=destination&id=${destinations?.[2]?.id_destino}&in=${dates?.[0]}&out=${dates?.[1]}&pax=2|21,21|0|0`
                  ),
                ]}
              >
                <img
                  src={
                    "https://panel.marzahtravel.com/assets/uploads/carruseles/destinos/" +
                    destinations?.[2]?.imagen_destino
                  }
                  className="img-collage shadow hover-image w-100"
                  alt=""
                  style={{ height: "192px" }}
                />
                <div className="overlay-text text-center align-items-center w-100">
                  <span
                    className="text-white"
                    style={{
                      fontSize: "3rem",
                      textShadow: "rgba(0, 0, 0, 0.51) 0px 1rem 3rem",
                    }}
                  >
                    {destinations?.[2]?.nombre_destino.substring(0, 20)}...
                  </span>
                </div>
              </div>
            </div>
          </Col>
          <Col
            lg={4}
            md={4}
            sm={12}
            className="image-box rounded-5 p-0 shadow"
            style={{ cursor: "pointer" }}
            onClick={() => [
              window.scrollTo({ top: 0, behavior: "smooth" }),
              navigate(
                `/experiencias-resultado?t=destination&id=${destinations?.[3]?.id_destino}&in=${dates?.[0]}&out=${dates?.[1]}&pax=2|21,21|0|0`
              ),
            ]}
          >
            <img
              src={
                "https://panel.marzahtravel.com/assets/uploads/carruseles/destinos/" +
                destinations?.[3]?.imagen_destino
              }
              className="img-collage shadow hover-image w-100"
              alt=""
              style={{ height: "408px" }}
            />
            <div className="overlay-text text-center align-items-center w-100">
              <span
                className="text-white"
                style={{
                  fontSize: "3rem",
                  textShadow: "rgba(0, 0, 0, 0.51) 0px 1rem 3rem",
                }}
              >
                {destinations?.[3]?.nombre_destino?.substring(0, 20)}...
              </span>
            </div>
          </Col>
        </Row>
        <div className="d-lg-none d-grid m-0">
          <div
            className="image-box rounded-5 p-0 shadow"
            onClick={() => [
              window.scrollTo({ top: 0, behavior: "smooth" }),
              navigate(
                `/experiencias-resultado?t=destination&id=${destinations?.[0]?.id_destino}&in=${dates?.[0]}&out=${dates?.[1]}&pax=2|21,21|0|0`
              ),
            ]}
          >
            <img
              src={
                "https://panel.marzahtravel.com/assets/uploads/carruseles/destinos/" +
                destinations?.[0]?.imagen_destino
              }
              className="img-collage hover-image w-100"
              style={{ height: "250px", objectFit: "cover" }}
              alt=""
            />
            <div className="overlay-text text-center align-items-center w-100">
              <span
                className="text-white"
                style={{
                  fontSize: "3rem",
                  textShadow: "rgba(0, 0, 0, 0.51) 0px 1rem 3rem",
                }}
              >
                {destinations?.[0]?.nombre_destino?.substring(0, 20)}...
              </span>
            </div>
          </div>
          <div
            className="image-box spacing-top rounded-5 p-0 shadow mt-4"
            onClick={() => [
              window.scrollTo({ top: 0, behavior: "smooth" }),
              navigate(
                `/experiencias-resultado?t=destination&id=${destinations?.[1]?.id_destino}&in=${dates?.[0]}&out=${dates?.[1]}&pax=2|21,21|0|0`
              ),
            ]}
          >
            <img
              src={
                "https://panel.marzahtravel.com/assets/uploads/carruseles/destinos/" +
                destinations?.[1]?.imagen_destino
              }
              className="img-collage hover-image w-100"
              style={{ height: "250px", objectFit: "cover" }}
              alt=""
            />
            <div className="overlay-text text-center align-items-center w-100">
              <span
                className="text-white"
                style={{
                  fontSize: "3rem",
                  textShadow: "rgba(0, 0, 0, 0.51) 0px 1rem 3rem",
                }}
              >
                {destinations?.[1]?.nombre_destino?.substring(0, 20)}...
              </span>
            </div>
          </div>
          <div
            className="image-box mt-4 rounded-5 p-0 shadow"
            onClick={() => [
              window.scrollTo({ top: 0, behavior: "smooth" }),
              navigate(
                `/experiencias-resultado?t=destination&id=${destinations?.[2]?.id_destino}&in=${dates?.[0]}&out=${dates?.[1]}&pax=2|21,21|0|0`
              ),
            ]}
          >
            <img
              src={
                "https://panel.marzahtravel.com/assets/uploads/carruseles/destinos/" +
                destinations?.[2]?.imagen_destino
              }
              className="img-collage hover-image w-100"
              style={{ height: "250px", objectFit: "cover" }}
              alt=""
            />
            <div className="overlay-text text-center align-items-center w-100">
              <span
                className="text-white"
                style={{
                  fontSize: "3rem",
                  textShadow: "rgba(0, 0, 0, 0.51) 0px 1rem 3rem",
                }}
              >
                {destinations?.[2]?.nombre_destino?.substring(0, 20)}...
              </span>
            </div>
          </div>

          <div
            className="image-box rounded-5 p-0 shadow mt-4"
            onClick={() => [
              window.scrollTo({ top: 0, behavior: "smooth" }),
              navigate(
                `/experiencias-resultado?t=destination&id=${destinations?.[3]?.id_destino}&in=${dates?.[0]}&out=${dates?.[1]}&pax=2|21,21|0|0`
              ),
            ]}
          >
            <img
              src={
                "https://panel.marzahtravel.com/assets/uploads/carruseles/destinos/" +
                destinations?.[3]?.imagen_destino
              }
              className="img-collage hover-image w-100"
              style={{ height: "250px", objectFit: "cover" }}
              alt=""
            />
            <div className="overlay-text text-center align-items-center w-100">
              <span
                className="text-white"
                style={{
                  fontSize: "3rem",
                  textShadow: "rgba(0, 0, 0, 0.51) 0px 1rem 3rem",
                }}
              >
                {destinations?.[3]?.nombre_destino?.substring(0, 20)}...
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="section-about-reservation container ">
        <SectionAdvise />
      </div>

      <BannerParallax
        img={parallaxExperiencias}
        title={"Colecciona cada momento"}
        subtitle={
          "Sumérgete en nuestras experiencias especialmente diseñadas para ti"
        }
      />

      <div className="section-cards-hotel container">
        <CarruselHotels idSeccion={4} idTitulo={3} />
      </div>

      {/* <div className="section-pays container py-5">
        <SectionPays />
      </div> */}

      <CarouselCards
        title={"Encuentra más colecciones aquí"}
        cardsInfo={collections}
        seccion={"collections"}
      />
      <CheckOutCart
        arrDatos={arrSession}
        urlSession={() => saveURL(location?.pathname, location?.search)}
        setAlert={setShowAlert}
        showAlert={showAlert}
        setAlertMessage={"Se agrego una nueva actividad"}
      />
    </div>
  );
};
